import { createFileRoute } from "@tanstack/react-router";
import AdminOccasionDetailPage from "@/admin/pages/occasion-detail";

export const Route = createFileRoute("/admin/occasions/$id")({
  component: AdminOccasionDetailPage,
});
